import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { Calendar } from './components/Calendar'
import { type Campaign } from '@/pages/schedule-agent'

export default function FigmaSlopCalendar({ posts }: { posts: Campaign['posts'] }) {
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }))
  return (
    <DndContext sensors={sensors}>
      <Calendar initialPosts={posts} />
    </DndContext>
  )
}
